import React from 'react';
import { useForm } from 'react-hook-form';
import Logo from '../../assets/images/logo.svg';
import { useAuth } from '../../Context/AuthContext';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function Otp() {
  const form = useForm();
  const navigate = useNavigate();
  const { checkotp, isAuthenticated, profile, sendConfirmationEmail } = useAuth();
  const {
    register,
    handleSubmit,
  } = form;

  const onSubmit2 = async (data) => {
    const { otp } = data;
    const email = localStorage.getItem('email');
    const concatenatedOTP = otp.reduce((acc, digit) => acc + digit, '');

    const result = await checkotp(email, "otp", concatenatedOTP);
    if (result || isAuthenticated) {
      const from = new URLSearchParams(window.location.search).get('from');


      if (from === 'signup' && result) {
        await profile()

        navigate('/');

      } else if (result) {
        navigate('/reset-password');
      }
    }

    form.reset();
  };
  const handleResendClick = (event) => {
    event.preventDefault();
    sendConfirmationEmail({ email: localStorage.getItem('email') });
  };


  return (
    <div className="Login-container">
      <div className="component-holder">
        <div className="filter">
          <div className="header-holder">
            <img className="logo" src={Logo} alt="logo" />
            <p>Intelligent Heritage Explorer</p>
          </div>
          <div className="login-form  ">
            <form
              className="form-login-holder form-forgetpassword-holder  form-otp-holder"
              onSubmit={handleSubmit(onSubmit2)}
              noValidate
            >
              <div className="otp-input-holder">
                <label className='otplabel otp-label'>Enter the code</label>
                <div className="otp-input">
                  {[...Array(6)].map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      {...register(`otp[${index}]`, {
                        required: true,
                        minLength: 1,
                        maxLength: 1,
                        pattern: /[0-9]/,
                      })}
                      maxLength={1}
                      className="otp-field"
                    />
                  ))}
                </div>
                <a className='resend-code' href='#' onClick={handleResendClick}>Resend Code</a>

              </div>

              <div>
                <button className="login-button" type="submit">
                  Confirm
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}